import PrimaryMarketOdd from '@models/base/PrimaryMarketOdd';

export default class PlaceholderOdd implements PrimaryMarketOdd {
    id: number;
    name: string;
    value: number;
    isLocked: boolean;
    constructor(
        id: number,
        name: string,
        value: number,
        isLocked: boolean,
    ) {
        this.id = id;
        this.isLocked = isLocked;
        this.name = name;
        this.value = value;
    }
}
